import React from 'react';
import clsx from 'clsx';
import ISlideFrame from '@/components/interfaces/SlideFrame';
import isMissingImage from '@/utils/isMissingImage';

interface FrameTileProps {
  frame: ISlideFrame;
  selected: boolean;
  onPreview: (frame: ISlideFrame | null) => void;
  onSelect: (id: number) => void;
}

const FrameTile = ({ frame, selected, onPreview, onSelect }: FrameTileProps) => {
  const { id, iconImageUrl, frameImageUrl } = frame;

  return (
    <div
      aria-label={frame.name}
      aria-pressed={selected}
      className={clsx(
        'tw-flex tw-h-16 tw-w-16 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded',
        'tw-border-2 tw-outline tw-outline-1 tw-outline-gray-300',
        'hover:tw-shadow-md hover:tw-shadow-tci-purple/50',
        'focus-visible:tw-outline-2 focus-visible:tw-outline-tci-purple focus-visible:tw-outline-offset-2',
        selected && 'tw-outline-2 tw-outline-tci-purple tw-shadow-md tw-shadow-tci-purple/50',
      )}
      role="button"
      tabIndex={0}
      onBlur={() => onPreview(null)}
      onClick={() => onSelect(id)}
      onFocus={() => onPreview(frame)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(id);
        }
      }}
      onMouseEnter={() => onPreview(frame)}
      onMouseLeave={() => onPreview(null)}
    >
      <img
        alt=""
        className="tw-max-h-full tw-max-w-full tw-rounded tw-drop-shadow-[1px_1px_2px_rgba(0,0,0,0.25)]"
        src={isMissingImage(iconImageUrl) ? frameImageUrl : iconImageUrl}
      />
    </div>
  );
};

export default FrameTile;
